import { metro } from '@/config/api';
import { formatStationForAPI } from '@/utils/stationUtils';

export async function searchMetro(from, to) {
  try {
    if (!from || !to) {
      throw new Error('Both from and to stations are required');
    }

    const fromStation = formatStationForAPI(from);
    const toStation = formatStationForAPI(to);

    const url = `${metro}/route?from=${fromStation}&to=${toStation}`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch metro data: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    if (error.message) {
      throw error;
    }
    throw new Error('Failed to fetch metro routes');
  }
}
